"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var remove_keys_1 = require("./remove-keys");
var filterEcommEvents = function (ecommEvent) {
    return remove_keys_1.removeKeys(ecommEvent, [
        'hitType',
        'customTrackerId',
        'ecommType',
        'actionName',
    ]);
};
exports.default = filterEcommEvents;
